import { Tag } from 'antd';
import BaseCellText from 'common/components/table/base-cell-text';
import { ICellRendererProps } from 'common/components/table/table.types';
import { deactivatedAccessCardName } from 'common/constans/access-card.constants';
import { DATE_SHORT_MMM_DD_YYYY } from 'common/constans/date.constants';
import { formatAddressLabel } from 'common/helpers/address.helper';
import { DateToFormat, formatCustomDateTime } from 'common/helpers/date.helper';
import { IAccessCardRead } from 'common/services/residents-service/residents.service.types';
import dayjs from 'dayjs';

const getValidPeriod = (rowData: IAccessCardRead) => {
  const isPeriod = rowData?.validFrom && rowData?.validTo;

  return isPeriod
    ? `${DateToFormat(rowData.validFrom, DATE_SHORT_MMM_DD_YYYY)} - ${DateToFormat(rowData.validTo, DATE_SHORT_MMM_DD_YYYY)}`
    : '';
};

export const accessCardColumns = [
  {
    key: 'owner',
    title: 'Owner',
    dataKey: 'owner',
    width: 140,
    fixed: 1,
    resizable: true,
    sortable: true,
  },
  {
    key: 'address',
    title: 'Address',
    dataKey: 'address',
    width: 280,
    minWidth: 280,
    resizable: true,
    sortable: false,
    flexGrow: 1,
    cellRenderer: (cell: ICellRendererProps<IAccessCardRead>) => {
      return formatAddressLabel(cell.rowData.address);
    },
  },
  {
    key: 'facilityCode',
    title: 'Facility code',
    dataKey: 'facilityCode',
    width: 140,
    fixed: 1,
    resizable: true,
    sortable: true,
  },
  {
    key: 'deviceId',
    title: 'Device ID',
    dataKey: 'deviceId',
    width: 120,
    fixed: 1,
    resizable: true,
    sortable: true,
  },
  {
    key: 'isShared',
    title: 'Is owner?',
    dataKey: 'isShared',
    width: 100,
    sortable: false,
    resizable: true,
    fixed: 1,
    cellRenderer: (cell: ICellRendererProps<IAccessCardRead>) => {
      return (
        <Tag className="eiq-tag" color={cell.cellData ? '#FFB68C' : '#C1FFEA'} style={{ color: '#292B2E' }}>
          {cell.cellData ? 'No' : 'Yes'}
        </Tag>
      );
    },
  },
  {
    key: 'cardClass',
    title: 'Card Class',
    dataKey: 'cardClass',
    width: 150,
    minWidth: 150,
    resizable: true,
    sortable: true,
    flexGrow: 1,
    cellRenderer: (cell: ICellRendererProps<IAccessCardRead>) => {
      return (
        cell?.rowData?.cardClass && (
          <Tag
            className="eiq-tag"
            color={cell?.rowData.cardClass === deactivatedAccessCardName ? '#E0E0E0' : '#C1FFEA'}
            style={{ color: '#292B2E' }}>
            {cell?.rowData.cardClass}
          </Tag>
        )
      );
    },
  },
  {
    key: 'additionalInformation',
    title: 'Description',
    dataKey: 'additionalInformation',
    width: 245,
    fixed: 1,
    resizable: true,
    sortable: false,
  },
  {
    key: 'registrationAddress',
    title: 'Address of registration',
    dataKey: 'registrationAddress',
    width: 200,
    fixed: 1,
    resizable: true,
    sortable: false,
  },
  {
    key: 'ValidityPeriod',
    title: 'Validity period',
    dataKey: 'ValidityPeriod',
    width: 195,
    minWidth: 150,
    resizable: true,
    sortable: false,
    getValue: getValidPeriod,
    cellRenderer: (cell: ICellRendererProps<IAccessCardRead>) => {
      return <BaseCellText>{getValidPeriod(cell?.rowData)}</BaseCellText>;
    },
    flexGrow: 1,
  },
  {
    key: 'isDeactivated',
    title: 'Deactivated?',
    dataKey: 'isDeactivated',
    width: 150,
    sortable: false,
    resizable: true,
    fixed: 1,
    cellRenderer: (cell: ICellRendererProps<IAccessCardRead>) => {
      return (
        <Tag className="eiq-tag" color={cell.cellData ? '#FFB68C' : '#C1FFEA'} style={{ color: '#292B2E' }}>
          {!cell.cellData ? 'No' : 'Yes'}
        </Tag>
      );
    },
  },
  {
    key: 'cardAccessLastActivityDate',
    title: 'Last Activity Date',
    dataKey: 'cardAccessLastActivityDate',
    width: 180,
    minWidth: 150,
    resizable: true,
    sortable: false,
    flexGrow: 1,
    cellRenderer: (cell: ICellRendererProps<IAccessCardRead>) => {
      const local = cell.cellData ? dayjs.utc(cell.cellData).local() : null;
      return formatCustomDateTime(local ? local.toDate() : null, true);
    },
  },
];

export const residentAccessCardColumns = accessCardColumns.filter((i) => i.key !== 'address');
